// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"32b298ce","732":"fe4f8c0a"}[chunkId] + ".chunk.css";
};